import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

// Styles
import styles from './index.module.sass';

//Objects
import accountObject from '../Queries/myAccountObject';

// Queries
import closeSession from '../Queries/closeSession';

export default function MyAccountMobile({
  history,
  getCookie,
  setOpen,
  setshowMenu,
  setshow,
  show,
  itemSelectedAccount,
  setItemSelectedAccount,
}) {
  const { location = {} } = history;
  const { hash = '' } = location;

  const { url = '', children = [] } = accountObject || {};
  const { t } = useTranslation('menuheader');

  const cont = process.env.REACT_APP_COUNTRY;

  return (
    <div
      className={styles.departamentContainer}
      onClick={() => {
        //La variable setShow es la que muestra o no el menú de inicio (Con el bóton dorado de "Mi cuenta")
        if (itemSelectedAccount) {
          setItemSelectedAccount(false);
          setshow(false);
        } else {
          setshow(true);
          setItemSelectedAccount(true);
          setshowMenu(true);
        }
      }}
      style={{
        order: accountObject.index,
      }}>
      <div className={styles.userIcon}>
        {!show ? (
          <Button type='submit' variant='contained' color='primary' className={`${styles.button}`}>
            <div className={styles.iconShipment}>
              <span className={`material-icons-outlined`}>person</span>
              {t('myaccount')}
            </div>
          </Button>
        ) : (
          <div className={styles.myAccount}>
            <div
              className={styles.titleAccount}
              onClick={() => {
                setItemSelectedAccount(false);
                setshow(false);
                setshowMenu(true);
                setshow(true);
              }}>
              <span className={`material-icons-outlined ${styles.IconMyAccount}`}>person</span>
              <div className={styles.TitleMyAccount}>{t('myaccount')}</div>
            </div>
          </div>
        )}

        <div className={`${styles.families} ${styles[itemSelectedAccount && children.length > 0]}`}>
          {children.map((subval, subkey) => {
            const external = (
              <a
                className={styles.familyTitle}
                key={subkey}
                href={`${subval.url}`}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                  setItemSelectedAccount(false);
                  setOpen(false);
                  setshowMenu(false);
                  setshow(false);
                }}>
                <span className={`material-icons-outlined ${styles.familyIcon}`}>
                  {subval?.icon || 'arrow_right_alt'}
                </span>
                <div>{t(subval.id)}</div>
              </a>
            );

            const normal = (
              <Link
                className={styles.familyTitle}
                key={subkey}
                to={`${url}${subval.url}${hash}`}
                onClick={() => {
                  setItemSelectedAccount(false);
                  setOpen(false);
                  setshowMenu(false);
                  setshow(false);
                }}>
                <span className={`material-icons-outlined ${styles.familyIcon}`}>
                  {subval?.icon || 'arrow_right_alt'}
                </span>
                <div>{t(subval.id)}</div>
              </Link>
            );
            if (subval.external) {
              if (subval.country && subval.country === cont) return external;
              else if (subval.country && subval.country !== cont) return null;
              else return external;
            } else {
              if (subval.country && subval.country === cont) return normal;
              else if (subval.country && subval.country !== cont) return null;
              else return normal;
            }
          })}
          <div
            className={styles.familyTitle}
            onClick={() => {
              setItemSelectedAccount(false);
              closeSession({ history });
            }}>
            <span className={`material-icons-outlined ${styles.familyIcon}`}>logout</span>
            <div>{t('logout')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
